<template>
  <div class="page-container">
    <div class="main">
      <page
          :url="url"
          :form="form"
          @reset="reset"
          @select-data="handleSelectionChange"
      >
        <template slot="tableSearch">
          <el-form-item :label="$t('text.creationTime')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="isShowConfigMethod"
                     size="small">
            {{ $t('text.addConfig') }}
          </el-button>
        </template>

        <template slot="tableColumn">

          <el-table-column
              width="100"
              prop="statisticsDate"
              :label="$t('text.date')"
              :formatter="$formatter.formatDate"
              align="center"
          ></el-table-column>
        </template>

        <template slot="tableColumn">

          <template v-if="this.$store.state.isPK">
            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <!-- JZ 代收 -->
            <el-table-column
                width="140px"
                prop="jzPayInAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzCollectionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzPayInMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzCollectionRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzPayInFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzCollectionCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzPayInTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzCollectionGrossProfit')"
                align="center"
            ></el-table-column>

            <!-- JZ 代付 -->
            <el-table-column
                width="140px"
                prop="jzPayOutAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzDisbursementAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzPayOutMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzDisbursementRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzPayOutFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzDisbursementCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzPayOutTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzDisbursementGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column
                width="140px"
                prop="jzTotalTransactionAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzTotalTransactionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="jzTotalGrossProfit"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.jzTotalGrossProfit')"
                align="center"
            ></el-table-column>


            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <!-- EP 代收 -->
            <el-table-column
                width="140px"
                prop="epPayInAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epCollectionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epPayInMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epCollectionRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epPayInFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epCollectionCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epPayInTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epCollectionGrossProfit')"
                align="center"
            ></el-table-column>

            <!-- EP 代付 -->
            <el-table-column
                width="140px"
                prop="epPayOutAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epDisbursementAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epPayOutMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epDisbursementRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epPayOutFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epDisbursementCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epPayOutTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epDisbursementGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column
                width="140px"
                prop="epTotalTransactionAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epTotalTransactionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="epTotalGrossProfit"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.epTotalGrossProfit')"
                align="center"
            ></el-table-column>

            <template v-if="this.$store.state.payplatformName === 'KaroPay'">
              <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

              <!-- loong1 代收 -->
              <el-table-column
                  width="140px"
                  prop="loongPayInAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongCollectionAmount')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongPayInMerFee"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongCollectionRevenue')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongPayInFee"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongCollectionCost')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongPayInTotalAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongCollectionGrossProfit')"
                  align="center"
              ></el-table-column>

              <!-- loong1 代付 -->
              <el-table-column
                  width="140px"
                  prop="loongPayOutAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongDisbursementAmount')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongPayOutMerFee"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongDisbursementRevenue')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongPayOutFee"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongDisbursementCost')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongPayOutTotalAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongDisbursementGrossProfit')"
                  align="center"
              ></el-table-column>

              <el-table-column
                  width="140px"
                  prop="loongTotalTransactionAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongTotalTransactionAmount')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="loongTotalGrossProfit"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.loongTotalGrossProfit')"
                  align="center"
              ></el-table-column>

              <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

              <!-- CARD 代收-->
              <el-table-column
                  width="140px"
                  prop="cardPayInAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.cardCollectionAmount')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="cardPayInMerFee"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.cardCollectionRevenue')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="cardPayInFee"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.cardCollectionCost')"
                  align="center"
              ></el-table-column>
              <el-table-column
                  width="140px"
                  prop="cardPayInTotalAmount"
                  :formatter="$formatter.FenToYuanToThousandth"
                  :label="$t('text.cardCollectionGrossProfit')"
                  align="center"
              ></el-table-column>

              <!--          &lt;!&ndash; CARD 代付&ndash;&gt;-->
              <!--          <el-table-column-->
              <!--              width="140px"-->
              <!--              prop="cardPayOutAmount"-->
              <!--              :formatter="$formatter.FenToYuanToThousandth"-->
              <!--              :label="$t('text.cardDisbursementAmount')"-->
              <!--              align="center"-->
              <!--          ></el-table-column>-->
              <!--          <el-table-column-->
              <!--              width="140px"-->
              <!--              prop="cardPayOutMerFee"-->
              <!--              :formatter="$formatter.FenToYuanToThousandth"-->
              <!--              :label="$t('text.cardDisbursementRevenue')"-->
              <!--              align="center"-->
              <!--          ></el-table-column>-->
              <!--          <el-table-column-->
              <!--              width="140px"-->
              <!--              prop="cardPayOutFee"-->
              <!--              :formatter="$formatter.FenToYuanToThousandth"-->
              <!--              :label="$t('text.cardDisbursementCost')"-->
              <!--              align="center"-->
              <!--          ></el-table-column>-->
              <!--          <el-table-column-->
              <!--              width="140px"-->
              <!--              prop="cardPayOutTotalAmount"-->
              <!--              :formatter="$formatter.FenToYuanToThousandth"-->
              <!--              :label="$t('text.cardDisbursementGrossProfit')"-->
              <!--              align="center"-->
              <!--          ></el-table-column>-->
            </template>
          </template>
          <template v-if="this.$store.state.isBD">
            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
            <!-- Bkash 代收 -->
            <el-table-column
                width="140px"
                prop="bkashPayInAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashCollectionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashPayInMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashCollectionRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashPayInFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashCollectionCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashPayInTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashCollectionGrossProfit')"
                align="center"
            ></el-table-column>

            <!-- Bkash 代付 -->
            <el-table-column
                width="140px"
                prop="bkashPayOutAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashDisbursementAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashPayOutMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashDisbursementRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashPayOutFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashDisbursementCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashPayOutTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashDisbursementGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column
                width="140px"
                prop="bkashTotalTransactionAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashTotalTransactionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="bkashTotalGrossProfit"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.bkashTotalGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <!-- Nagad 代收 -->
            <el-table-column
                width="140px"
                prop="nagadPayInAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadCollectionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadPayInMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadCollectionRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadPayInFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadCollectionCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadPayInTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadCollectionGrossProfit')"
                align="center"
            ></el-table-column>

            <!-- Nagad 代付 -->
            <el-table-column
                width="140px"
                prop="nagadPayOutAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadDisbursementAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadPayOutMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadDisbursementRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadPayOutFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadDisbursementCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadPayOutTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadDisbursementGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column
                width="140px"
                prop="nagadTotalTransactionAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadTotalTransactionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="nagadTotalGrossProfit"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.nagadTotalGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <!-- Rocket 代收 -->
            <el-table-column
                width="140px"
                prop="rocketPayInAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketCollectionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketPayInMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketCollectionRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketPayInFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketCollectionCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketPayInTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketCollectionGrossProfit')"
                align="center"
            ></el-table-column>

            <!-- Rocket 代付 -->
            <el-table-column
                width="140px"
                prop="rocketPayOutAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketDisbursementAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketPayOutMerFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketDisbursementRevenue')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketPayOutFee"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketDisbursementCost')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketPayOutTotalAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketDisbursementGrossProfit')"
                align="center"
            ></el-table-column>

            <el-table-column
                width="140px"
                prop="rocketTotalTransactionAmount"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketTotalTransactionAmount')"
                align="center"
            ></el-table-column>
            <el-table-column
                width="140px"
                prop="rocketTotalGrossProfit"
                :formatter="$formatter.FenToYuanToThousandth"
                :label="$t('text.rocketTotalGrossProfit')"
                align="center"
            ></el-table-column>
          </template>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <el-table-column
              width="140px"
              prop="totalMerFee"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.totalCollectionRevenue')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="totalFee"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.totalDisbursementCost')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="totalGrossProfit"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.totalGrossProfit')"
              align="center"
          ></el-table-column>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <!-- 其他 -->

          <el-table-column
              width="140px"
              prop="laborCost"
              :label="$t('text.laborCost')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="totalAgentMerCost"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.totalAgentMerCost')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="totalAgentAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.totalAgentAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="localDailyCost"
              :label="$t('text.localDailyCost')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="totalOtherCosts"
              :label="$t('text.totalOtherCosts')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <el-table-column
              width="140px"
              prop="collectionAndPaymentAmount"
              :label="$t('text.collectionAndPaymentAmount')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="netProfit"
              :label="$t('text.netProfit')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="netProfitUsdt"
              :label="$t('text.netProfitUsdt')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="cumulativeNetProfitUsdt"
              :label="$t('text.cumulativeNetProfitUsdt')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="netProfitAsPercentageOfGrossProfitUsdt"
              :label="$t('text.netProfitAsPercentageOfGrossProfitUsdt')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="usdtWalletBalance"
              :label="$t('text.usdtWalletBalance')"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>
        </template>
      </page>

      <PkKaroFinancialAffairsConfig
          :isShowLoongConfig="isShowPkKaroConfig"
          @update:isShowLoongConfig="(value) => isShowPkKaroConfig = value"
      />
      <PkFirstFinancialAffairsLoongConfig
          :isShowLoongConfig="isShowPkFirstConfig"
          @update:isShowLoongConfig="(value) => isShowPkFirstConfig = value"
      />
      <BdKaroFinancialAffairsConfig
          :isShowLoongConfig="isShowBdKaroConfig"
          @update:isShowLoongConfig="(value) => isShowBdKaroConfig = value"
      />
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "@/utils/Constant";
import moment from "moment/moment";
import PkKaroFinancialAffairsConfig from "@/views/route/financialAffairsConfig/PkKaroFinancialAffairsConfig.vue";
import PkFirstFinancialAffairsConfig from "@/views/route/financialAffairsConfig/PkFirstFinancialAffairsConfig.vue";
import BdKaroFinancialAffairsConfig from "@/views/route/financialAffairsConfig/BdKaroFinancialAffairsConfig.vue";

export default {
  name: "route",
  components: {
    PkKaroFinancialAffairsConfig: PkKaroFinancialAffairsConfig,
    PkFirstFinancialAffairsLoongConfig: PkFirstFinancialAffairsConfig,
    BdKaroFinancialAffairsConfig: BdKaroFinancialAffairsConfig,
    page: Page,
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      timeDate: [moment().subtract(0, 'days').format('yyyyMMDD'), moment().format('yyyyMMDD')],
      multipleSelection: [],
      strMultipleSelection: [],
      url: "/statistics-channel/financial-statistics",
      action: "",
      form: {
        routeStatus: "",
        startDate: moment().subtract(0, 'days').format('yyyyMMDD'),
        endDate: moment().format('yyyyMMDD'),
      },
      formLabelWidth: "100px",
      formData: null,
      value: {},
      upstreamList: [],
      loading: false,
      exporting: false,
      isShowPkKaroConfig: false,
      isShowPkFirstConfig: false,
      isShowBdKaroConfig: false,
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({routeId}) => routeId
      );
    },
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(3, 'days').format('yyyyMMDD');
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/statistics-channel/financial-statistics/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.upstreamStatisticsExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
    isShowConfigMethod() {
      if (this.$store.state.isPK) {
        if (this.$store.state.payplatformName === 'KaroPay') {
          this.isShowPkKaroConfig = true;
        } else if (this.$store.state.payplatformName === 'FirstPay') {
          this.isShowPkFirstConfig = true;
        }
      }

      if (this.$store.state.isBD) {
        if (this.$store.state.payplatformName === 'KaroPay') {
          this.isShowBdKaroConfig = true;
        }
      }
    },
  },
  created() {
    this.$axios
        .get("/order/orderPayment/selectPackagedUpstream", {params: {}})
        .then((res) => {
          this.upstreamList = res.data;
        });
  },
  refresh() {
    this.tableChange(this.form);
  },

};
</script>
